import { createFileRoute, redirect } from "@tanstack/react-router"
import { QueryBoundary } from "~/components/query-boundary"
import PageLoading from "~/components/ui/page-loading"
import { BackButton } from "~/components/layout/back-button"
import { EditProfileForm } from "~/features/profile-edit/components/edit-profile-form"
import { useUser } from "~/features/profile/hooks/use-user"

export const Route = createFileRoute("/profile/edit")({
  component: EditProfilePage,
})

function EditProfilePage() {
  return (
    <QueryBoundary loadingFallback={<EditProfilePending />}>
      <EditProfileContent />
    </QueryBoundary>
  )
}

function EditProfileContent() {
  const { data: user } = useUser()

  if (!user) {
    throw redirect({
      to: "/",
      search: {
        tab: "feed",
      },
    })
  }

  return (
    <div className="flex flex-col">
      <BackButton variant="overlay" />
      <EditProfileForm user={user} />
    </div>
  )
}

function EditProfilePending() {
  return <PageLoading noHeader />
}
